<div class="min-h-screen bg-slate-100">
  <header class="bg-white shadow-sm">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div class="flex items-center space-x-4">
        <a routerLink="/applications" class="text-slate-500 hover:text-slate-800">
          <!-- Heroicon: arrow-left -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
        </a>
        <h1 class="text-2xl font-bold text-slate-900">User Management</h1>
      </div>
    </div>
  </header>

  <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    
    <!-- Invite New Reviewer Section -->
    <div class="bg-white shadow rounded-lg p-6 mb-8">
      <h2 class="text-lg font-semibold text-slate-900">Invite New Reviewer</h2>
      <p class="mt-1 text-sm text-slate-600">Enter the user's email prefix. An invitation will be sent allowing them to sign up to the portal.</p>
      
      <form (ngSubmit)="handleInviteReviewer()" class="mt-4 flex flex-col sm:flex-row sm:items-start sm:space-x-2">
        <div class="flex-grow w-full sm:w-auto">
          <label for="email-prefix" class="sr-only">Email prefix</label>
          <div class="flex rounded-md shadow-sm">
            <input 
              type="text" 
              name="email-prefix" 
              id="email-prefix" 
              [(ngModel)]="inviteEmailPrefix"
              class="block w-full min-w-0 flex-1 rounded-none rounded-l-md border-0 py-1.5 text-slate-900 ring-1 ring-inset ring-slate-300 placeholder:text-slate-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" 
              placeholder="john.doe">
            <span class="inline-flex items-center rounded-r-md border border-l-0 border-slate-300 bg-slate-50 px-3 text-slate-500 sm:text-sm">@cordic.com</span>
          </div>
        </div>
        <button 
          type="submit" 
          [disabled]="inviteLoading() || !inviteEmailPrefix()"
          class="mt-2 sm:mt-0 w-full sm:w-auto inline-flex items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:bg-slate-400 disabled:cursor-not-allowed transition-colors">
            @if(inviteLoading()) {
              <svg class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
              <span>Sending...</span>
            } @else {
              <span>Send Invite</span>
            }
        </button>
      </form>

      @if (inviteSuccess()) {
        <div class="mt-3 rounded-md bg-green-50 p-3">
          <div class="flex items-start">
            <div class="flex-shrink-0"><svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" /></svg></div>
            <div class="ml-3"><p class="text-sm text-green-700">{{ inviteSuccess() }}</p></div>
          </div>
        </div>
      }
      @if (inviteError()) {
        <div class="mt-3 rounded-md bg-red-50 p-3">
          <div class="flex items-start">
            <div class="flex-shrink-0"><svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.293 7.293a1 1 0 011.414 0L10 8.586l1.293-1.293a1 1 0 111.414 1.414L11.414 10l1.293 1.293a1 1 0 01-1.414 1.414L10 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L8.586 10 7.293 8.707a1 1 0 010-1.414z" clip-rule="evenodd" /></svg></div>
            <div class="ml-3"><p class="text-sm text-red-700">{{ inviteError() }}</p></div>
          </div>
        </div>
      }
    </div>

     @if (loading()) {
      <div class="text-center py-16">
        <p class="text-slate-500">Loading users...</p>
      </div>
    } @else if (error()) {
        <div class="bg-red-50 text-red-800 p-4 rounded-lg">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.293 7.293a1 1 0 011.414 0L10 8.586l1.293-1.293a1 1 0 111.414 1.414L11.414 10l1.293 1.293a1 1 0 01-1.414 1.414L10 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L8.586 10 7.293 8.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <p class="font-semibold text-sm">{{ error() }}</p>
              <p class="mt-2 text-sm">The user management functionality relies on a backend function that may be misconfigured. If this error persists, please contact a backend developer to ensure the 'get_all_users' RPC function is correctly defined and has the necessary permissions.</p>
            </div>
          </div>
        </div>
    } @else {
        <div class="bg-white shadow overflow-hidden rounded-lg">
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-slate-200">
                <thead class="bg-slate-50">
                    <tr>
                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">User</th>
                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Status</th>
                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Last Sign In</th>
                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Role</th>
                        <th scope="col" class="relative px-6 py-3"><span class="sr-only">Actions</span></th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y divide-slate-200">
                    @for(user of users(); track user.id) {
                        <tr>
                            <td class="px-6 py-4 whitespace-nowrap">
                                <div class="text-sm font-medium text-slate-900">{{ user.full_name || 'N/A' }}</div>
                                <div class="text-sm text-slate-500">{{ user.email }}</div>
                                <div class="text-xs text-slate-400 mt-1">Joined: {{ formatDate(user.created_at) }}</div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap">
                                @if (user.email_confirmed_at) {
                                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">Active</span>
                                } @else {
                                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">Awaiting Verification</span>
                                }
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-500">
                                {{ formatDate(user.last_sign_in_at) }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap">
                                @if(user.is_reviewer) {
                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800">Reviewer</span>
                                } @else {
                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-slate-100 text-slate-800">Standard User</span>
                                }
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                <button 
                                    (click)="toggleRole(user)" 
                                    [disabled]="actionInProgress() === user.id || user.id === currentUser()?.id"
                                    class="px-3 py-1 text-sm font-medium rounded-md shadow-sm border border-slate-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                    [class.bg-yellow-500]="user.is_reviewer"
                                    [class.text-white]="user.is_reviewer"
                                    [class.hover:bg-yellow-600]="user.is_reviewer"
                                    [class.bg-indigo-600]="!user.is_reviewer"
                                    [class.text-white]="!user.is_reviewer"
                                    [class.hover:bg-indigo-700]="!user.is_reviewer"
                                >
                                    @if (actionInProgress() === user.id) {
                                        <span>Updating...</span>
                                    } @else if (user.is_reviewer) {
                                        <span>Revoke Reviewer</span>
                                    } @else {
                                        <span>Make Reviewer</span>
                                    }
                                </button>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="5" class="px-6 py-12 text-center text-slate-500">
                                No users found. As users attempt to sign up, they will appear here.
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
          </div>
        </div>
    }
  </main>
</div>